module.exports = __webpack_public_path__ + "img/gb879-86-3x24.prt.80fdbed1.jpg";